export const copyCorrelationId = async (
  correlationId: string,
  clipboard: Pick<Clipboard, 'writeText'> | undefined = navigator.clipboard,
): Promise<boolean> => {
  try {
    if (!clipboard) return false;
    await clipboard.writeText(correlationId);
    return true;
  } catch {
    return false;
  }
};
